import React from 'react';
import config from '../config/config';

const ICON_URLS = {
  directionsTrain: `${config.icons.baseUrl}${config.icons.directionsTrain}`,
};

const LOADING_STATION_MESSAGE = "最寄駅を検索中...";
const STATION_LIST_SEPARATOR = ' / ';
const STATION_DISTANCE_PREFIX = '約';

/**
 * 最寄駅コンポーネント
 */
const NearestStations = ({ stations }) => {
  // 駅がない場合（空配列）は何も表示しない
  // 配列かどうかで判定
  if (Array.isArray(stations) && stations.length === 0) {
    return null;
  }

  let message;

  if (stations == null) {
    // データがない場合（初期状態）
    message = LOADING_STATION_MESSAGE;
  } else if (typeof stations === 'string') {
    // stationsが文字列の場合（ローディングメッセージなど）
    message = stations;
  } else if (Array.isArray(stations) && stations.length > 0) {
    // 駅がある場合：駅名と距離を "駅名 (約距離)" 形式にフォーマット
    message = stations
      .map(station => `${station.name} (${STATION_DISTANCE_PREFIX}${station.distance})`)
      .join(STATION_LIST_SEPARATOR);
  } else {
    // その他のケース（念のため）
    message = "";
  }

  // 共通のレンダリング部分
  return (
    <div className="nearest-stations">
      <i
        className="svg-icon-black"
        style={{ backgroundImage: `url('${ICON_URLS.directionsTrain}')` }}
      ></i>
      <span className="station">{message ?? ""}</span>
    </div>
  );
};

export default NearestStations;